<div class="validation-container">

  <div class="selected-category-container">
    <h3>{{ 'request_v2.create-request-dialog.validate-information.request-category' | translate }}</h3>
    <div class="selected-category-display">
      <div class="category-header">
        <i [class]="selectedCategory?.icon || 'icon-construction'" class="category-icon"></i>
        <h3 class="category-title">{{ selectedCategory?.name }}</h3>
      </div>
      <p *ngIf="selectedSubcategory" class="subcategory-title">{{ selectedSubcategory?.name }}</p>
    </div>
  </div>

  <div class="location-section">
    <h3 class="location-title">{{ 'request_v2.create-request-dialog.validate-information.location' | translate }}</h3>
    <div class="location-display">
      <div class="location-address">
        <ng-container *ngIf="location?.address; else noAddress">{{ location.address }}</ng-container>
        <ng-template #noAddress>{{ 'request_v2.create-request-dialog.validate-information.no-address' | translate }}</ng-template>
      </div>
      <div class="location-marker">
        <svg xmlns="http://www.w3.org/2000/svg" width="19" height="20" viewBox="0 0 19 20" fill="none">
          <line x1="9.58691" y1="1" x2="9.58691" y2="19" stroke="black" stroke-linecap="round"/>
          <line x1="18.5" y1="10.0869" x2="0.5" y2="10.0869" stroke="black" stroke-linecap="round"/>
          <circle cx="9.50025" cy="9.99977" r="6.52174" fill="#F6F6F6" stroke="black" stroke-linecap="round"/>
          </svg>
      </div>
    </div>
  </div>

  <div class="request-info-section">
    <h3>{{ 'request_v2.create-request-dialog.validate-information.request-description' | translate }}</h3>
    <div class="description-text">{{ requestDescription }}</div>
  </div>

  <div class="linked-requests-section" *ngIf="requestLinks && requestLinks.length > 0">
    <h3>{{ 'request_v2.links.title' | translate }}</h3>
    <div class="linked-requests-list">
      <div class="linked-request-item" *ngFor="let link of requestLinks">
        <div class="linked-request-top">
          <span class="linked-request-type">{{ getLabelForType(link.type) | translate | uppercase }}</span>
          <span class="linked-request-id">{{ getLinkedRequestDisplayId(link) }}</span>
        </div>
        <div class="linked-request-bottom">
          <span>{{ getRequestCategoryLabel(link) }}</span>
          <span class="sep" *ngIf="link?.linkedRequest?.department?.name">|</span>
          <span>{{ link?.linkedRequest?.department?.name }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="attached-files-section" *ngIf="attachedFiles && attachedFiles.length > 0">
    <h3>{{ 'request_v2.create-request-dialog.validate-information.shared-images' | translate }}</h3>
    <div class="attached-files-list">
      <div class="file-preview-grid">
        <div class="attached-file-item" *ngFor="let file of attachedFiles; let i = index">
          <div class="file-preview">
            <img 
              *ngIf="isImageFile(file)"
              [src]="getFileImageSrc(file)" 
              [alt]="file.name" 
              (error)="handleImageError($event)"
              class="file-preview-image"
            />
            <div *ngIf="!isImageFile(file)" class="file-icon-container" [ngClass]="{'pdf-file': isPdfFile(file), 'doc-file': isWordFile(file), 'excel-file': isExcelFile(file)}">
              <img *ngIf="isPdfFile(file)" src="assets/images/pdf-file.svg" alt="PDF File">
              <img *ngIf="isWordFile(file)" src="assets/images/word-file.svg" alt="Word File">
              <img *ngIf="isExcelFile(file)" src="assets/images/sheets-file.svg" alt="Excel File">
              <i *ngIf="!isPdfFile(file) && !isWordFile(file) && !isExcelFile(file)" class="icon icon-files"></i>
            </div>
          </div>
          <div class="file-info">
            <div class="file-name" [title]="file.name">{{ file.name }}</div>
          </div>
          <a class="delete-file-link" (click)="deleteFile(i)">
            {{ 'request_v2.create-request-dialog.validate-information.delete' | translate }}
          </a>
        </div>
      </div>
    </div>
  </div>


  <div class="error-message" *ngIf="errorMessage">
    <div class="error-content">
      <i class="error-icon icon-warning"></i>
      <span>{{ errorMessage }}</span>
      <button class="close-error" (click)="errorMessage = ''">&times;</button>
    </div>
  </div>
</div>
